import Enum from "./Enum";

/**
 * NOTE: this value is not persisted in the database.
 * It is merely a flag that the service layer translates into:
 *   outcome.completed = null - Planned
 *   outcome.completed = <now> - Completed
 *
 * NOTE: The safest way to determine if an outcome is actually completed
 * is to coerce its `completed` property to a boolean. This is a compatible
 * way to check both V1 and V2 outcome objects.
 */
export default Enum.create( {
	PLANNED: "Planned",
	COMPLETED: "Completed",
} );

